export class SectionTextModel {
    text: string;
    link?: string;
    href?: string;
    newPage?: boolean;
}


// WEBPACK FOOTER //
// ./src/app/model/sectionTextModel.ts